/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
// AddUsersTab.tsx
import React, { useState } from 'react'
import AddUsersTabContent from './AddUsersTabContent'

interface IUsersData {
    id?: any | null;
    firstName: string;
    lastName?: string | null | undefined;
    email: string;
    password: string;
    clientId: number;
    passwordResetKey?: any | null;
    resetKeySentOn?: any | null;
    isDeleted: boolean;
    isActive: boolean;
    timeZone?: any | null;
    phone?: any | null;
    roleId?: any | null;
    createdBy: string;
    createdOn: string;
    createdSource: string;
    modifiedBy?: any | null;
    modifiedOn?: any | null;
    modifiedSource?: any | null;
    //For user role
    hasRole: boolean;
    name: string;
    userID:any;
    hasWebAccess: boolean;
    hasAPIAccess : boolean;
    roleName: string | null;
  }
  
// interface SelectedUserId {
//     id: number;
//   }
  
interface UsersTabProps {
    page: string;
    roleData: IUsersData[];
    closeModal: any;
    onUserSelect: (userId: number, checked: boolean) => void;
    selectedUserIds: number[];
    setSelectedUserIds: React.Dispatch<React.SetStateAction<number[]>>;
}

function AddUsersTab({  roleData, onUserSelect, selectedUserIds, setSelectedUserIds }: UsersTabProps): JSX.Element {
    const [selectAllChecked, setSelectAllChecked] = useState(false);

    const onItemSelect = (userId: number, checked: boolean): void => {
        if (checked) {
            setSelectedUserIds(prevState => [...prevState, userId]);
        } else {
            setSelectedUserIds(prevState => prevState.filter(id => id !== userId));
        }
        onUserSelect(userId, checked);
    };
    
    return (
        <div>
            <div className='px-[16px] pt-[10px] mb-[60px]'>
                {roleData.map((userData, index) => (
                    <AddUsersTabContent
                        key={index}
                        userData={userData}
                        index={index}
                        onItemSelect={() => onItemSelect(userData.userID, !selectedUserIds.includes(userData.userID))}
                        selected={selectedUserIds.includes(userData.userID)}
                        selectAllChecked={selectAllChecked} // Pass selectAllChecked prop
                    />
                ))}
            </div>
        </div>
    );
}

export default AddUsersTab;
